<template>
  <b-form @submit.prevent="save">
    <b-row>
      <b-col md="6" >
        <b-form-group :label="$t('FIRST_NAME')">
          <b-form-input v-model="userData.name" type="text"></b-form-input>
          <validation-description :show="$v.userData.name.$dirty && $v.userData.name.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group :label="$t('EMAIL')">
          <b-form-input v-model="userData.email"  type="text"></b-form-input>
          <validation-description :show="$v.userData.email.$dirty && $v.userData.email.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group :label="$t('ROLE')">
          <b-form-select v-model="userData.role.id">
            <option :value="null">-</option>
            <option :key="index" v-for="(role, index) in roles" :value="role.id">
              {{ role.name }}
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="6" >
        <b-form-group :label="$t('STATUS')">
         <b-form-select :options="options_status" v-model="userData.is_active"></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
        <b-col>
          <app-button-submit :loading="loading_save" ></app-button-submit>
        </b-col>
        <b-col>
          <delete-button
                         @click="showDeleteDialog=true"
                         class="pull-right">
          </delete-button>

          <confirmation-dialog :show="showDeleteDialog" @confirm="deleteApp" @cancel="showDeleteDialog=false"> </confirmation-dialog>
        </b-col>
    </b-row>

  </b-form>
</template>

<script>
  import _findKey from 'lodash/findKey'
  import AppButtonSubmit from '@/components/app/AppSubmit'
  import ConfirmationDialog from '@/components/app/form/AppConfirmationDialog'
  import DeleteButton from '@/components/app/AppDelete'
  import {getRoleList} from "@/services/role"
  import {updateUser} from "@/services/user";
  import {toast} from "@/shared/plugins/toastr";
  import {getErrorMessage} from '@/mixins/error/getErrorMessage'
  import {required} from 'vuelidate/lib/validators'
  import ValidationDescription from '@/components/app/form/AppValidationDescription'
  import {deleteUser} from "@/services/user";
  import i18n from '@/locale/index'
  import AppButton from "@/components/app/AppButton";
  import {cloneDeep, isNumber} from "lodash";

  export default {
    name: "user-edit-form",
    props:{
      id:{
        type:Number
      }
    },
    mixins:[getErrorMessage],
    data() {
      return {
        showDeleteDialog:false,
        select: this.selected,
        editAsidePanel:'',
        options_status:[
          {value:null, text:'-'},
          {value:1, text: i18n.t('ACTIVE')},
          {value:0, text: i18n.t('NOTACTIVE')}
        ],
        userData:{
          id:null,
          name:null,
          email:null,
          password:null,
          role:{
            id:null,
          },
          is_active:null,
        },
        roles:[],
        loadingReset:false,
        loading_save:false,
      }
    },
    editAsidePanel: false,
    components:{
      AppButton,
      AppButtonSubmit,
      DeleteButton,
      ConfirmationDialog,
      ValidationDescription

    },
    computed:{
       userIndex(){
         if(!this.id){
           null
         }
         let userList =  this.$store.getters['user/getSearchList']
         let index = _findKey(userList, (el)=>{
           return el.id === this.id
         })
         return index
       },
       user(){
         return  this.$store.getters['user/getSearchList'][this.userIndex]
       },

    },
    validations:{
      userData: {
        name:{required},
        email:{required},
      }
    },
    methods:{
      save(){
        this.$v.userData.$touch()
        if(this.$v.userData.$invalid){
          toast({
            'title': this.$t('VALIDATION_FAILED'),
            'message': null,
            'type': 'error',
            'timeout': 4000
          })
          return
        }
        this.loading_save= true
        const request = {
          id: this.userData.id,
          name: this.userData.name,
          email: this.userData.email,
          role: this.userData.role,
        }
          updateUser(this.userData.id, request)
            .then(()=>{
              toast({
                title: this.$t('NOTIFICATIONS.SAVE_SUCCESS.TITLE'),
                message: this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
                'type': 'success',
                'timeout': 2000
              })
                this.$store.dispatch('user/actionSearch')
                this.$emit('closePanel', this.editAsidePanel)

            }, error=>{
              toast({
                title: this.$t('NOTIFICATIONS.SAVE_ERROR.TITLE'),
                message: this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE', {value: this.getMessages(error)}),
                'type': 'error',
                'timeout': 6000
              })
          }).finally(()=>{
            this.loading_save = false
          })
      },
      deleteApp(){
        deleteUser(this.userData.id)
          .then(response => {
              this.showDeleteDialog = false,
            toast({
              'title': this.$t('NOTIFICATIONS.DELETE_SUCCESS.MESSAGE'),
              'message': null,
              'type': 'success',
              'timeout': 2000
            })
            this.$store.dispatch('user/actionSearch')
            setTimeout(() => {
              this.$emit('closePanel', this.editAsidePanel)
            }, 500)

          },error => {
              toast({
                'title': "Delete  fail",
                'message': this.getMessages(error),
                'type': 'error',
                'timeout': 6000
              })
            })
      },
      getRoles() {
          let roleList = []
          getRoleList()
             .then(response => {
               roleList = response.data
               this.roles = roleList;
          })
      },
    },

    created(){
      this.getRoles()
      this.userData = cloneDeep(this.user);
    }
  }
</script>

<style scoped>
.table.-no-padding td{
  padding-left: 0;
  padding-right: 0;
}
.btn-del{
  background: none;
  font-size: 18px;
  border: unset;
}
</style>
